export function rand() {
  return crypto.getRandomValues(new Uint32Array(1))[0]
}
